module.exports = __webpack_public_path__ + "img/制御工学7_3_3.55c3866a.png";